module.exports = require("event-stream");


//////////////////
// WEBPACK FOOTER
// external "event-stream"
// module id = 100
// module chunks = 0